import * as React from "react";
import { Form, Input, Row, Col } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import IconButton from "@/components/ui/IconButton";
import { CapitalizationActualsPlaceholderName } from "@/types/newLinkBuilder";

interface IProps {
    formula: string,
    formulaLocation: string,
    setFormulaLocation: (value: string) => void,
    handlePlaceholder: (name: CapitalizationActualsPlaceholderName) => void
}

const FormulaBuilderForm: React.FC<IProps> = ({ formula, formulaLocation, setFormulaLocation, handlePlaceholder }) => {
    return (
        <div>
            <Form.Item
                name={"formulaLocation"}
                className="flex flex-col gap-2 !mb-2"
            >
                <Row
                    align={"middle"}

                >
                    <Col span={6} style={{ display: 'flex', justifyContent: 'start' }}>
                        <label htmlFor="formulaLocation" className="">
                            Formula Location:
                        </label>
                    </Col>

                    <Col span={16} style={{ display: 'flex', justifyContent: 'start' }}>
                        <Input
                            placeholder="A1"
                            id="formulaLocation"
                            value={formulaLocation}
                            onChange={(e) => setFormulaLocation(e.target.value)}
                        />
                    </Col>

                    <Col span={2} style={{ display: 'flex', justifyContent: 'end' }}>
                        <IconButton
                            icon={<UploadOutlined />}
                            onClick={() => handlePlaceholder(CapitalizationActualsPlaceholderName.FormulaLocationCellReference)}
                        />
                    </Col>
                </Row>
            </Form.Item>

            <Form.Item
                name={"formulaBuilder"}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'start',
                    textAlign: 'left',
                    gap: '20px',
                    marginBlock: '20px',
                }}
            >
                <span className="">
                    Formula Builder:
                </span>

                <code
                    className="block !p-5 bg-white border border-gray-200 rounded-md font-mono text-sm whitespace-pre-wrap mt-2"
                >
                    {formula}
                </code>
            </Form.Item>
        </div>
    )
}

export default FormulaBuilderForm; 